<template>
  <div class="border-t border-gray-300 pt-3 mt-6">
    <simple-dropdown v-model="model.type" :options="identifierOptions" :label="$t('customerIdentifier.type.label')" />
    <fancy-input v-model="model.identifier" :label="$t('customerIdentifier.identifier.label')" class="mt-4" />
    <small>
      <a href="#" class="text-sm underline" @click="createRandom()">{{ $t('customerIdentifier.createRandom') }}</a>
    </small>
    &nbsp;&nbsp;
    <a
      href="#"
      class="text-sm underline"
      @click="$emit('click:delete', model)"
      v-text="$t('general.action.removeSth', [$t('customerIdentifier.label')])"
    />
  </div>
</template>

<script>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useModel } from '@/hooks/model';
import SimpleDropdown from '@/components/utils/forms/SimpleDropdown.vue';
import FancyInput from '@/components/utils/forms/FancyInput.vue';
import { CUSTOMER_IDENTIFIER_TYPES } from '@/constants';

export default {
  name: 'CustomerIdentifierForm',
  components: {
    FancyInput,
    SimpleDropdown,
  },
  props: {
    modelValue: { type: Object, default: () => ({ type: 10, identifier: '' }) },
  },
  emits: ['click:delete'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const model = useModel(props, emit);

    const identifierOptions = ref(Object.values(CUSTOMER_IDENTIFIER_TYPES).map((val) => (
      { key: val.toString(), label: t(`customerIdentifier.type.${val}`), value: val }
    )));

    return {
      model,
      identifierOptions,
    };
  },
  methods: {
    createRandom() {
      const arr = new Uint32Array(32);
      crypto.getRandomValues(arr);
      this.model.identifier = Buffer.from(arr)
        .toString('hex');
    },
  },
};
</script>
